import gql from "graphql-tag";

const query = gql`
  query Customer($customerId: ID) {
    customer(customerId: $customerId) {
      id
      description
      userIds
      contracts {
        id
      }
      partnerId
    }
  }
`;

export default customerId => ({
  query,
  skip: !customerId,
  variables: { customerId },
});
